export const TRANSACTION_EVENT_TYPE_NAMES = {
    PUBLIC_VIEW_SETTINGS_REQUEST: 'publicViewSettingsRequest',
    PUBLIC_VIEW_SETTINGS_RESPONSE: 'publicViewSettingsResponse'
} as const
